export enum QuoteLevelEnum {
    Regular = "Regular",
    Bronze = "Bronze",
    Silver = "Silver",
    Gold = "Gold"
}